// Source: data/v2/ — compiled by scripts/parse-resume-data.mjs at prestart/prebuild.
import type { ResumeExperience, ResumeProject, ResumeConfig } from 'types/resume';
import experienceRaw from './generated/experience.json';
import projectsRaw   from './generated/projects.json';
import configRaw     from './generated/config.json';

const allExperience = experienceRaw as ResumeExperience[];

export const experience = allExperience.filter(e => e.type === 'employment');
export const education  = allExperience.filter(e => e.type === 'education');
export const projects   = projectsRaw as ResumeProject[];
export const config     = configRaw   as ResumeConfig;
